import type { SystemIconType } from '@shared/designSystem/SystemIcon';
import { FeatureFlag, OldFeatureFlag } from './Organization';

export type SidebarSectionKey = 'principal' | 'comunicacion' | 'gestion' | 'bottom';

export const sidebarSectionTitles: Record<Exclude<SidebarSectionKey, 'bottom'>, string> = {
	principal: 'Principal',
	comunicacion: 'Comunicación',
	gestion: 'Gestión',
};

export interface SidebarEntry {
	path?: string; // if it should navigate to a path.
	requiredFlag?: FeatureFlag | OldFeatureFlag | FeatureFlag[] // if it should be shown only if the flag is true e.g. "hasPresenteeismTable" or "WebDashboardMap"
	liteAllowed?: boolean; // if it should be shown if the user has the lite plan.
	externalLink?: string; //  If it should open an external link.
	icon: SystemIconType;
	section: SidebarSectionKey;
}
export const sidebarEntries: Record<string, SidebarEntry> = {
	Resumen: {
		path: '/resumen',
		requiredFlag: OldFeatureFlag.hasPresenteeismTable,
		liteAllowed: true,
		icon: 'dashboard',
		section: 'principal',
	},
	// Frecuencia: {
	// 	path: '/frecuencia',
	// 	requiredFlag: OldFeatureFlag.hasFrequencyTable,
	// 	icon: 'clock',
	// 	section: 'principal',
	// },
	Listado: {
		path: '/listado',
		requiredFlag: OldFeatureFlag.hasPresenteeismTable,
		liteAllowed: true,
		icon: 'listado',
		section: 'principal',
	},
	Roster: {
		path: '/roster',
		requiredFlag: FeatureFlag.PresenteeismRoster,
		icon: 'roster',
		section: 'principal',
	},
	Mapa: {
		path: '/mapa',
		requiredFlag: FeatureFlag.WebDashboardMap,
		icon: 'map',
		section: 'principal',
	},
	Notificaciones: {
		path: '/notificaciones',
		requiredFlag: FeatureFlag.DashboardNotification,
		icon: 'bell',
		section: 'comunicacion',
	},
	Solicitudes: {
		path: '/solicitudes',
		requiredFlag: FeatureFlag.RequestsWeb,
		icon: 'email',
		section: 'comunicacion',
	},
	Alertas: {
		path: '/alertas',
		requiredFlag: FeatureFlag.AlertsWeb,
		icon: 'alert',
		section: 'comunicacion',
	},
	Comunicaciones: {
		path: '/comunicaciones',
		requiredFlag: FeatureFlag.DashboardNotification,
		icon: 'megaphone',
		section: 'comunicacion',
	},
	Colaboradores: {
		path: '/colaboradores',
		requiredFlag: OldFeatureFlag.hasWhitelistColaborators,
		liteAllowed: true,
		icon: 'people',
		section: 'gestion',
	},
	'App Qontact': {
		path: '/qontact-app',
		requiredFlag: FeatureFlag.AppAdoptionWeb,
		icon: 'device-mobile',
		section: 'gestion',
	},
	'Qontact Points': {
		path: '/qontactPoints',
		liteAllowed: true,
		requiredFlag: FeatureFlag.QontactPointCreationWeb,
		icon: 'qr',
		section: 'gestion',
	},
	'Banco de Horas': {
		path: '/bancoDeHoras',
		requiredFlag: FeatureFlag.HourBankSync,
		icon: 'bank',
		section: 'gestion',
	},
	Novedades: {
		path: '/novedades',
		requiredFlag: FeatureFlag.NovedadesWeb,
		icon: 'send',
		section: 'gestion',
	},
	Reportes: {
		path: '/reportes',
		requiredFlag: FeatureFlag.MetabaseWebReports,
		icon: 'chart2',
		section: 'gestion',
	},
	'Configuración': {
		path: '/configuracion',
		requiredFlag: [FeatureFlag.NovedadesWeb, FeatureFlag.AdminUserCreationWeb, FeatureFlag.Presenteeism2FA],
		icon: 'settings',
		section: 'bottom',
	},
};
